import Model from './model';





export default Model.extend( {

    endpoint: 'contracts?apiVersion=2.0',
    
    defaults() {
        return {
            title: '',
            no: '',
            cluster: undefined,
            start_date: null,
            finish_date: null,
            customer: undefined,
            assigned_organization: undefined,
            grant_task_creation: false,
            description: '',
            groups: [],
        };
    },

    clone() {
        const other = Model.prototype.clone.call( this );
        other.set( 'groups', this.get( 'groups' )
            .map( ({ objects, types, ...attrs }) => ({
                objects: [...objects],
                types: [...types],
                ...attrs,
            }) ) )
        return other;
    },
    
} );


// WEBPACK FOOTER //
// ./src/js/model/contract.js